export const PURCHASE_METHODS = ['cash', 'loan', 'lease'] as const;
export type PurchaseMethod = typeof PURCHASE_METHODS[number];

export const isTruthy = <T>(thing: T): thing is Exclude<T, null | undefined | 0 | '' | false> =>
  Boolean(thing);
